import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import PendingGridView from './PendingGridView'
import RenewalGridView from './RenewalGridView'
import PendingPoliciesGridView from './PendingPoliciesGridView'

export default () => (
  <Grid container spacing={24}>
    <Grid item xs={6}>
      <Typography variant="h6" gutterBottom>
        Apólices Vincendas
      </Typography>
      <RenewalGridView />
    </Grid>
    <Grid item xs={6}>
      <Typography variant="h6" gutterBottom>
        Renovações Pendentes
      </Typography>
      <PendingGridView />
    </Grid>
    <Grid item xs={6}>
      <Typography variant="h6" gutterBottom>
        Apólices Pendentes
      </Typography>
      <PendingPoliciesGridView />
    </Grid>
  </Grid>
)
